module.exports = __webpack_public_path__ + "static/media/07.724d3231.jpg";